import { MenuItem, Pagination, Typography, Select, SelectChangeEvent } from '@mui/material';
import { range } from 'ramda';

import { ReactComponent as ArrowDownIcon } from 'src/assets/images/arrowDownIcon.svg';
import Box from 'src/components/Box';

import styles from './styles';

type TablePaginationActionsProps = {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: React.MouseEvent<HTMLButtonElement>, newPage: number) => void;
};

const TablePaginationActions: React.FC<TablePaginationActionsProps> = props => {
  const { count, page: pageIndex, rowsPerPage, onPageChange } = props;
  const pageCount = Math.ceil((count || 0) / rowsPerPage);

  const handlePageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
    const currentEvent = event as React.MouseEvent<HTMLButtonElement>;
    onPageChange(currentEvent, newPage - 1);
  };

  const handleSelectChange = (event: SelectChangeEvent<number>) => {
    const selectedPage = Number(event.target.value);
    onPageChange(null, selectedPage - 1);
  };

  return (
    <>
      <Pagination count={pageCount} page={pageIndex + 1} onChange={handlePageChange} />

      <Box sx={styles.goToSelectContainer}>
        <Typography sx={styles.goToSelectLabel} variant="body1" component="span">
          Go to page{' '}
        </Typography>
        <Select
          id="goToSelect"
          sx={styles.goToSelect}
          value={pageIndex + 1}
          onChange={handleSelectChange}
          IconComponent={ArrowDownIcon}
        >
          {range(1, pageCount + 1).map(pageNumber => {
            return (
              <MenuItem key={pageNumber} value={pageNumber}>
                {pageNumber}
              </MenuItem>
            );
          })}
        </Select>
      </Box>
    </>
  );
};

export default TablePaginationActions;
